const CSV_FORMULA_PREFIX = /^[\s]*[=+\-@]/;

function escapeCsvValue(value) {
    if (value === null || value === undefined) {
        return '';
    }

    let stringValue = String(value);
    if (CSV_FORMULA_PREFIX.test(stringValue)) {
        stringValue = `'${stringValue}`;
    }
    if (/[",\r\n]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
}

export function buildCsv(rows, columns) {
    const headerRow = columns.map((column) => escapeCsvValue(column.header ?? column.key)).join(',');
    const bodyRows = rows.map((row) => (
        columns
            .map((column) => escapeCsvValue(column.value ? column.value(row) : row[column.key]))
            .join(',')
    ));

    return [headerRow, ...bodyRows].join('\r\n');
}

export function downloadCsv(filename, csvText) {
    const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export function sanitizeCsvFilenamePart(value) {
    return String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_-]+/g, '')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');
}
